import { render, staticRenderFns } from "./add-operate.vue?vue&type=template&id=3946d374&scoped=true&"
import script from "./add-operate.vue?vue&type=script&lang=js&"
export * from "./add-operate.vue?vue&type=script&lang=js&"
import style0 from "./add-operate.vue?vue&type=style&index=0&id=3946d374&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3946d374",
  null
  
)

export default component.exports